import * as R from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { useElementSize, useLocalStorage } from "usehooks-ts";
import Avatar from "./Avatar";
import { LinkifiedText } from "./LinkifiedText";

export const CollapsableCell = ({ cell, activeApp }) => {
  const [globalHidden, setGlobalHidden] = useLocalStorage(`collapseCell${activeApp}`, true);
  const [hidden, setHidden] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const [containElementRef, { height }] = useElementSize();
  const textElementRef = useRef<HTMLSpanElement>(null);
  const textHeight = textElementRef?.current?.scrollHeight ?? 0;

  const handleClick = (event) => {
    if ((event.target as HTMLElement).closest("a")) {
      return;
    }
    // Check if text is selected
    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    if (event.detail === 1 && (textHeight > 50 || height > 50)) {
      setHidden(!hidden);
      setShowButton(!showButton);
    }
  };

  useEffect(() => {
    setHidden(globalHidden);
  }, [globalHidden]);
  const globalShowButton = globalHidden && (textHeight > 50 || height > 50);
  return (
    <div
      className={"d-flex align-items-end showExpandOnHover w-100"}
      style={{ margin: ".2em 0" }}
      onClick={(e) => handleClick(e)}
    >
      <div ref={containElementRef} style={{ flexGrow: 1 }}>
        <span
          style={{ cursor: globalShowButton ? "pointer" : "default" }}
          className={`${hidden ? "two-line-text-truncate" : ""}`}
          ref={textElementRef}
        >
          <LinkifiedText text={cell} />
        </span>
      </div>
      {(showButton || globalShowButton) && (
        <div style={{ width: "30px", position: "relative" }}>
          <button
            className={`expandText addIcon ${hidden === true ? "" : " rotateIcon"}`}
            onClick={(e) => handleClick(e)}
          >
            <i className="fa fa-angle-down"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export const CellEditFormatter = (cell, row?, param3?, extraData?) => {
  const activeApp = sessionStorage.getItem("activeApp");
  return (
    <span className="expandable-cell" style={{ overflow: "hidden", cursor: "pointer" }}>
      <i style={{ color: "#dddddd", cursor: "pointer" }} />
      <div className="d-flex p-0 m-0 align-items-center">
        {/* TODO: is name available here? use in avatar */}
        {extraData && extraData?.avatar && <Avatar id={R.path(extraData.avatar, row)} name="" />}
        {extraData && extraData?.icon && <div style={{ marginRight: "2px" }}>{extraData.icon}</div>}
        <CollapsableCell cell={cell} activeApp={activeApp} />
      </div>
    </span>
  );
};
